import React, { useEffect } from 'react';
import ApplicationRouter from 'routes';
import { getSystemLocales } from 'store/forms/actions';
import { useDispatch } from 'react-redux';
import './styles/main.scss';

const App = () => {
  const dispatch = useDispatch();

  /**
   * @description Retrieves (all) application locales for translations from the BackEnd.
   * This is needed only once per apps lifetime, and is actually irrelevant to whether user is
   * authenticated or not. AuthGuard handles locales loading state, to show it in combination with
   * its(AuthGuard's) loading state; in order to avoid flickering between spinners.
   */
  useEffect(() => {
    const storedLanguage =
      localStorage.getItem('appLanguage') ||
      process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
    dispatch(getSystemLocales(storedLanguage));
  }, [dispatch]);

  return (
      <ApplicationRouter />
  );
};

export default App;
